
import { GTMDashboardEvent } from "@/app/infrastructures/misc/gtm-event/custom-events/dashboard-events";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import { prop, Vue } from "vue-class-component";

class Props {
  data = prop<any>({
    default: {},
    type: Object
  });
  disabled = prop<boolean>({
    default: false,
    type: Boolean
  });
}
export default class DashboardOptions extends Vue.with(Props) {
  toDetail(cardData: any, tooltip: any) {
    GTMDashboardEvent(cardData?.gtmEventName, undefined, ["timestamp"]);
    tooltip?.hide();
    DashboardController.onToDetail({
      ...cardData,
      title: this.translateTitle(cardData?.title)
    });
  }
  toDownload(cardData: any, tooltip: any) {
    tooltip?.hide();
    DashboardController.onDownloadXlsx(cardData);
  }

  translateTitle(title: string) {
    if (!title) {
      return "";
    }

    if (!title?.startsWith("dashboard.")) {
      return title;
    }

    return String(this.$t(title));
  }
}
